import Vue from "vue";
import Router from "vue-router";
import settings from "../settings";

import Layout from "@/containers/TheLayout.vue";

/* Router Modules */
import authRouter from "./modules/auth";
import errorsRouter from "./modules/errors";

// Containers

Vue.use(Router);

export const constantRoutes = [
  {
    path: "/upgrade-announcement",
    component: () => import("@/views/UpgradeAnnouncement")
  },
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        component: () => import("@/views/Index"),
        name: "Index",
        meta: {
          title: "首頁"
        }
      },
      {
        path: "/search/:keyword",
        component: () => import("@/views/SearchResult"),
        name: "SearchResult",
        meta: {
          title: "所有活動公告"
        }
      },
      {
        path: "/event-optmize-test",
        component: () => import("@/views/Test"),
        name: "test",
        meta: {
          title: "首頁"
        }
      },
      {
        path: "/about",
        component: () => import("@/views/pages/About"),
        name: "About"
      },
      {
        path: "/activity/:id",
        component: () => import("@/views/Activity"),
        name: "Activity",
        meta: {
          title: "活動"
        }
      },
      {
        path: "/activityList/:type",
        component: () => import("@/views/ActivityList"),
        name: "ActivityList"
      },
      {
        path: "/newsList",
        component: () => import("@/views/NewsList"),
        name: "NewsList"
      },
      {
        path: "/news/:id",
        component: () => import("@/views/News"),
        name: "News"
      },
      {
        path: "/seat/:eventId/:sessionId",
        component: () => import("@/views/order/SelSt"),
        name: "SelSt",
        meta: {
          order: true
        }
      },
      {
        path: "/confirmSeat/:eventId/:sessionId",
        component: () => import("@/views/order/ConfirmSt"),
        name: "ConfirmSt",
        meta: {
          order: true
        }
      },
      {
        path: "/order/:eventId/:sessionId",
        component: () => import("@/views/order/Step1"),
        name: "Order1",
        meta: {
          order: true
        }
      },
      {
        path: "/confirm/:eventId/:sessionId",
        component: () => import("@/views/order/Step2"),
        name: "Order2",
        meta: {
          order: true
        }
      },
      {
        path: "/checkout/:eventId/:sessionId",
        component: () => import("@/views/order/Step3"),
        name: "Order3",
        meta: {
          order: true
        }
      },
      {
        path: "/done/:orderId",
        component: () => import("@/views/order/Done"),
        name: "Done"
      },

      ...authRouter
    ]
  },
  {
    path: "/pages",
    redirect: "/pages/login",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "404",
        name: "404",
        component: () => import("@/views/pages/404"),
        hidden: true
      }
    ]
  },
  {
    path: "/test",
    component: () => import("@/views/pages/Test")
  },
  {
    path: "*",
    redirect: "/pages/404",
    hidden: true
  }
];

let routers = new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  mode: "history",
  // base: "/" + settings.publicPath,
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
});

export default routers;

export const asyncRoutes = [
  /** When your routing table is too long, you can split it into small modules */
  errorsRouter,
  { path: "*", redirect: "/error/404", hidden: true }
];
